export default __webpack_public_path__ + "static/media/mnr.bc9debb0.svg";